import React from 'react';
import styled from 'styled-components';
import Text from '@service-victoria/component-library/components/Text';
import Tick from '@service-victoria/component-library/components/Icons/Tick';
import colors from '@service-victoria/component-library/utils/colors';

const ThankWapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 2px solid ${colors.green};
  max-width: 160px;
  height: 50px;

  span {
    color: ${colors.green};
  }
`;

const TickWrapper: React.FC = styled.div`
  svg {
    width: 20px;
    height: 20px;
    margin-top: 2px;
    margin-right: 10px;
  }
`;

const ThankYou: React.FC<{ text: string }> = ({ text = 'Thank you' }) => {
  return (
    <ThankWapper data-testid='ThankYou-CompletionSurvey'>
      <TickWrapper>
        <Tick />
      </TickWrapper>
      <Text.Body fontWeight='bold' as='span'>
        {text}
      </Text.Body>
    </ThankWapper>
  );
};

export default ThankYou;
